import { useState } from 'react';

const topics = [
  { id: 1, title: '悬疑烧脑特辑', desc: '高分反转神作精选，考验你的推理能力', tag: '热门', imageSeq: 'index-01' },
  { id: 2, title: '国产佳片巡礼', desc: '近年口碑爆棚的华语电影合集', tag: '推荐', imageSeq: 'index-02' },
  { id: 3, title: '周末喜剧夜', desc: '轻松解压，笑到停不下来的爆笑电影', tag: '新上', imageSeq: 'index-03' },
  { id: 4, title: '科幻世界漫游', desc: '硬核科幻与视觉奇观的终极盛宴', tag: '精选', imageSeq: 'index-04' },
  { id: 5, title: '治愈系动画', desc: '温暖人心的动画电影，适合全家观看', tag: '暖心', imageSeq: 'index-05' },
  { id: 6, title: '动作片专场', desc: '肾上腺素飙升的硬派动作大片', tag: '劲爆', imageSeq: 'index-06' },
  { id: 7, title: '经典重温计划', desc: '那些年我们追过的电影经典之作', tag: '经典', imageSeq: 'index-07' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">按主题分类的精选电影合集，快速找到你想看的类型</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.slice(0, 3).map((topic) => (
            <IndexCard key={topic.id} topic={topic} />
          ))}
          <div className="sm:col-span-2 lg:col-span-1 grid grid-cols-1 gap-4 md:gap-5">
            {topics.slice(3, 4).map((topic) => (
              <IndexCard key={topic.id} topic={topic} />
            ))}
          </div>
          <div className="sm:col-span-2 lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {topics.slice(4, 7).map((topic) => (
              <IndexCard key={topic.id} topic={topic} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function IndexCard({ topic }: { topic: typeof topics[0] }) {
  const [imgError, setImgError] = useState(false);

  const imageUrls: Record<string, string> = {
    'index-01': 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20detective%20scene%20with%20warm%20amber%20lighting%20film%20noir%20style%20shadows%20and%20silhouettes%20vintage%20cinema%20atmosphere%20suspenseful%20mood%20rich%20textures%20dramatic%20composition&width=800&height=500&seq=index-01&orientation=landscape',
    'index-02': 'https://readdy.ai/api/search-image?query=Chinese%20countryside%20landscape%20with%20warm%20golden%20hour%20light%20traditional%20elements%20blend%20with%20modern%20cinematography%20soft%20nostalgic%20atmosphere%20poetic%20visual%20storytelling%20rich%20earthy%20tones&width=800&height=500&seq=index-02&orientation=landscape',
    'index-03': 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedic%20scene%20with%20warm%20cheerful%20lighting%20playful%20composition%20vibrant%20cinema%20aesthetic%20joyful%20atmosphere%20soft%20bokeh%20background%20lively%20energy%20movie%20poster%20style&width=800&height=500&seq=index-03&orientation=landscape',
    'index-04': 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20with%20neon%20accents%20and%20cosmic%20nebula%20background%20cinematic%20lighting%20epic%20scale%20sleek%20architecture%20deep%20space%20atmosphere%20dramatic%20visual%20composition&width=800&height=500&seq=index-04&orientation=landscape',
    'index-05': 'https://readdy.ai/api/search-image?query=Soft%20pastel%20animated%20style%20scene%20with%20warm%20sunlight%20gentle%20natural%20landscape%20cozy%20atmosphere%20whimsical%20storybook%20aesthetic%20healing%20visual%20mood%20dreamy%20composition%20tender%20lighting&width=800&height=500&seq=index-05&orientation=landscape',
    'index-06': 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20scene%20with%20dramatic%20lighting%20and%20dynamic%20composition%20urban%20night%20setting%20cinematic%20explosions%20warm%20orange%20and%20amber%20tones%20high%20energy%20blockbuster%20aesthetic&width=800&height=500&seq=index-06&orientation=landscape',
    'index-07': 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20golden%20light%20classic%20movie%20posters%20on%20textured%20wall%20nostalgic%20cinema%20atmosphere%20rich%20sepia%20tones%20old%20hollywood%20aesthetic%20timeless%20elegance&width=800&height=500&seq=index-07&orientation=landscape',
  };

  return (
    <a href="#cards" className="group relative block rounded-xl overflow-hidden bg-background-100 cursor-pointer">
      <div className="relative aspect-[16/10] overflow-hidden">
        {!imgError ? (
          <img
            src={imageUrls[topic.imageSeq]}
            alt={topic.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full bg-background-200 flex items-center justify-center">
            <i className="ri-movie-line text-3xl text-foreground-400"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-950 text-xs font-semibold whitespace-nowrap">{topic.tag}</span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">{topic.title}</h3>
        <p className="text-xs text-foreground-500 leading-relaxed">{topic.desc}</p>
      </div>
    </a>
  );
}